// const dataSources = require('./dataSources')

module.exports = {
    getAllUsers() {
        // return new Promise((resolve) => {
        //     // console.log('[MOCK getSubscriptionCurrent]')
        //     resolve({ success: true, current: {...dataSources.current}})
        // })
    },
}